/**
 * Fix for mobile header visibility on product pages
 * This script ensures the header is properly revealed when scrolling up on mobile product pages
 */
document.addEventListener('DOMContentLoaded', function() {
  // Run on all devices to ensure announcement bar stays visible
  const isMobile = window.innerWidth < 750;
  const isProductPage = window.location.pathname.includes('/products/');
  
  // RADICAL SOLUTION: Move announcement bar to end of body to override DOM order
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    console.log('[HEADER FIX] Moving announcement bar to end of body to override DOM stacking');
    
    // Remove announcement bar from its current position and append to body
    const announcementBarParent = announcementBar.parentNode;
    document.body.appendChild(announcementBar);
    
    // Force announcement bar to stay fixed at top with highest z-index
    announcementBar.style.position = 'fixed';
    announcementBar.style.top = '0';
    announcementBar.style.left = '0';
    announcementBar.style.width = '100%';
    announcementBar.style.zIndex = '9999';
    announcementBar.style.display = 'block';
    announcementBar.style.visibility = 'visible';
    announcementBar.style.opacity = '1';
    
    // Add padding to body to account for fixed announcement bar
    const announcementBarHeight = announcementBar.offsetHeight;
    document.body.style.paddingTop = announcementBarHeight + 'px';
    
    // Set CSS custom property for other elements to use
    document.documentElement.style.setProperty('--announcement-bar-height', announcementBarHeight + 'px');
    
    console.log('[HEADER FIX] Announcement bar moved to end of body with z-index:', announcementBar.style.zIndex);
  }
  
  // Run header behavior logic on both mobile and desktop, but with different conditions
  if ((isMobile && isProductPage) || (!isMobile)) {
    console.log('[HEADER FIX] Initializing mobile header fix for product pages');
    
    let lastScrollTop = 0;
    let headerVisible = true; // Start with header visible
    let isInitialLoad = true; // Flag to track initial page load
    
    // Get header elements
    const stickyHeader = document.querySelector('sticky-header');
    const headerWrapper = document.querySelector('.header-wrapper');
    const announcementBar = document.querySelector('.announcement-bar');
    const stickyBanner = document.querySelector('.product-sticky-banner');
    
    if (!stickyHeader || !headerWrapper) {
      console.log('[HEADER FIX] Header elements not found, aborting fix');
      return;
    }
    
    // Calculate announcement bar height (if it exists)
    const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
    console.log('[HEADER FIX] Announcement bar height:', announcementBarHeight);
    
    // Function to update banner position based on header visibility
    function updateBannerPosition(headerVisible) {
      if (stickyBanner && stickyBanner.classList.contains('is-sticky')) {
        // Ensure banner has same transition timing as header
        stickyBanner.style.transition = 'all 0.3s ease';
        
        let bannerTop = announcementBarHeight;
        if (headerVisible) {
          // Position banner to stick directly to header bottom (no gap)
          bannerTop += headerWrapper.offsetHeight - 1; // -1px to create slight overlap
        }
        stickyBanner.style.top = bannerTop + 'px';
        console.log('[HEADER FIX] Updated banner position:', bannerTop + 'px', 'Header visible:', headerVisible);
      }
    }
    
    // Store original header styles
    const originalHeaderStyles = {
      position: headerWrapper.style.position || '',
      top: headerWrapper.style.top || '',
      zIndex: headerWrapper.style.zIndex || '',
      transform: headerWrapper.style.transform || '',
      transition: headerWrapper.style.transition || ''
    };
    
    // Create a placeholder to prevent content jump when header becomes fixed
    function createHeaderPlaceholder() {
      const placeholder = document.createElement('div');
      placeholder.id = 'header-placeholder';
      placeholder.style.height = headerWrapper.offsetHeight + 'px';
      placeholder.style.display = 'none';
      headerWrapper.parentNode.insertBefore(placeholder, headerWrapper);
      return placeholder;
    }
    
    const headerPlaceholder = createHeaderPlaceholder();
    
    // Function to restore the normal header layout at the top of the page
    function restoreNormalHeader() {
      // Reset header to its original position in the DOM
      headerWrapper.style.position = originalHeaderStyles.position;
      headerWrapper.style.top = '0';
      headerWrapper.style.marginTop = '0'; // No margin needed - announcement bar is fixed
      headerWrapper.style.transform = 'none'; // Remove transform to avoid stacking context
      headerWrapper.style.display = 'block';
      headerWrapper.style.visibility = 'visible';
      headerWrapper.style.opacity = '1';
      headerWrapper.style.zIndex = '100'; // Force header z-index to be lower
      headerPlaceholder.style.display = 'none';
      
      // Ensure announcement bar stays visible
      if (announcementBar) {
        announcementBar.style.position = 'fixed';
        announcementBar.style.top = '0';
        announcementBar.style.zIndex = '999';
        announcementBar.style.display = 'block';
        announcementBar.style.visibility = 'visible';
        announcementBar.style.opacity = '1';
      }
      
      // Force all header-related elements to have lower z-index
      const headerElements = document.querySelectorAll('.header-wrapper, .section-header, .shopify-section-group-header-group, sticky-header');
      headerElements.forEach(el => {
        el.style.zIndex = '100';
      });
      
      headerVisible = true;
    }
    
    // Function to set the header to fixed position for scrolling
    function setFixedHeader() {
      headerWrapper.style.position = 'fixed';
      headerWrapper.style.top = announcementBarHeight + 'px'; // Position below announcement bar
      headerWrapper.style.left = '0';
      headerWrapper.style.width = '100%';
      headerWrapper.style.zIndex = '100'; // Lower than announcement bar's 999
      headerWrapper.style.transform = 'none'; // Remove transform to avoid stacking context
      headerWrapper.style.transition = 'top 0.3s ease-out, opacity 0.3s ease-out';
      headerPlaceholder.style.display = 'block';
      
      // Ensure announcement bar stays visible and above header
      if (announcementBar) {
        announcementBar.style.position = 'fixed';
        announcementBar.style.top = '0';
        announcementBar.style.zIndex = '999';
        announcementBar.style.display = 'block';
        announcementBar.style.visibility = 'visible';
        announcementBar.style.opacity = '1';
      }
    }
    
    // Initialize with normal header layout
    restoreNormalHeader();
    
    // Handle scroll events to show/hide header
    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Clear initial load flag once user starts scrolling
      if (isInitialLoad) {
        isInitialLoad = false;
      }
      
      // At the top of the page - show normal header layout
      if (scrollTop <= 50) {
        restoreNormalHeader();
        lastScrollTop = scrollTop;
        return;
      }
      
      // Past the top - use fixed positioning
      if (headerWrapper.style.position !== 'fixed') {
        setFixedHeader();
      }
      
      // Determine scroll direction
      const scrollingUp = scrollTop < lastScrollTop;
      
      if (scrollingUp) {
        // Scrolling UP - show header below announcement bar
        headerWrapper.style.transition = 'all 0.3s ease';
        headerWrapper.style.top = announcementBarHeight + 'px';
        headerWrapper.style.opacity = '1';
        headerWrapper.style.visibility = 'visible';
        headerVisible = true;
        updateBannerPosition(true);
        console.log('[HEADER FIX] Showing header on scroll up', scrollTop, lastScrollTop);
      } else {
        // Scrolling DOWN - hide header below announcement bar
        headerWrapper.style.transition = 'all 0.3s ease';
        headerWrapper.style.top = '-' + headerWrapper.offsetHeight + 'px';
        headerWrapper.style.opacity = '0';
        headerWrapper.style.visibility = 'hidden';
        headerVisible = false;
        updateBannerPosition(false);
        console.log('[HEADER FIX] Hiding header on scroll down', scrollTop, lastScrollTop);
      }
      
      // Update last scroll position
      lastScrollTop = scrollTop;
    });
    
    // Also handle touch events for mobile
    let touchStartY = 0;
    
    document.addEventListener('touchstart', function(e) {
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    
    document.addEventListener('touchmove', function(e) {
      if (!touchStartY) return;
      
      // Clear initial load flag once user starts touching
      if (isInitialLoad) {
        isInitialLoad = false;
      }
      
      const touchY = e.touches[0].clientY;
      const scrollingUp = touchY > touchStartY;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // At the top of the page - show normal header layout
      if (scrollTop <= 50) {
        restoreNormalHeader();
        return;
      }
      
      // Past the top - use fixed positioning
      if (headerWrapper.style.position !== 'fixed') {
        setFixedHeader();
      }
      
      if (scrollingUp && !headerVisible) {
        // Show header on upward swipe below announcement bar
        headerWrapper.style.transition = 'all 0.3s ease';
        headerWrapper.style.top = announcementBarHeight + 'px';
        headerWrapper.style.opacity = '1';
        headerWrapper.style.visibility = 'visible';
        headerVisible = true;
        updateBannerPosition(true);
        console.log('[HEADER FIX] Showing header on touch up');
      } else if (!scrollingUp && headerVisible) {
        // Hide header on downward swipe below announcement bar
        headerWrapper.style.transition = 'all 0.3s ease';
        headerWrapper.style.top = '-' + headerWrapper.offsetHeight + 'px';
        headerWrapper.style.opacity = '0';
        headerWrapper.style.visibility = 'hidden';
        headerVisible = false;
        updateBannerPosition(false);
        console.log('[HEADER FIX] Hiding header on touch down');
      }
      
      touchStartY = touchY;
    }, { passive: true });
    
    console.log('[HEADER FIX] Header fix initialized for', isMobile ? 'mobile' : 'desktop');
  } else {
    console.log('[HEADER FIX] Announcement bar DOM repositioning completed');
  }

});
